import {UI} from "../../../../../stem-core/ui/UIBase.js";
import {styleRule, registerStyle, StyleSheet} from "../../../../../stem-core/ui/Style.js";
import {Messages} from "../../../../Messages.js";
import {RefundModal} from "./RefundModal.jsx";
import {PopupMenu} from "../../../../ui/PopupMenu.jsx";
import type {Purchase} from "../../../../../client/state/PurchaseStore";

class PurchasePriceElementStyle extends StyleSheet {
    @styleRule
    container = {
        display: "flex",
        position: "relative",
        marginRight: -8,
        justifyContent: "flex-end",
    };

    @styleRule
    price = {
        fontSize: 14
    };
}

interface PurchasePriceElementOptions {
    purchase?: Purchase;
}

@registerStyle(PurchasePriceElementStyle)
export class PurchasePriceElement extends UI.Element<PurchasePriceElementOptions> {
    render() {
        const {purchase} = this.options;

        return [
            <div className={this.styleSheet.price}>{purchase.getAmount().toMainUnitString()}</div>,
            <PopupMenu items={[
                {
                    content: Messages.refund,
                    get disabled() {
                        return !purchase.isRefundable()
                    },
                    onClick: () => RefundModal.show({purchase}),
                }
            ]}/>
        ];
    }
}
